import { ReactNode } from 'react';
import { featureFlagsApiRef, useApi, useApp } from '@backstage/core-plugin-api';

/**
 * Renders its children only when the feature flag is active; otherwise renders
 * the app's NotFoundErrorPage.
 *
 * Unlike `FeatureFlagged` (which renders null when inactive), this keeps the
 * route's 404 behaviour, and being placed inside `element` the children stay
 * JSX children so route/plugin discovery still finds the page's route refs.
 */
export const RequireFeatureFlag = ({
  flag,
  children,
}: {
  flag: string;
  children: ReactNode;
}) => {
  const featureFlagsApi = useApi(featureFlagsApiRef);
  const { NotFoundErrorPage } = useApp().getComponents();

  if (!featureFlagsApi.isActive(flag)) {
    return <NotFoundErrorPage />;
  }

  return <>{children}</>;
};
